import React, { useState } from 'react';
import { toast } from 'sonner';
import { FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon, LinkedinIcon, MapPinIcon, PhoneIcon, MailIcon, ArrowRightIcon, CreditCardIcon, ChevronDownIcon, ChevronUpIcon, WalletIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  const [quickLinksOpen, setQuickLinksOpen] = useState(false);
  const [customerServiceOpen, setCustomerServiceOpen] = useState(false);
  const [shopByCategoryOpen, setShopByCategoryOpen] = useState(false);
  return <footer className="hidden md:block bg-white border-t border-gray-200 mt-8" data-id="element-2808" data-mp="3s140y6vesuzr">
      {/* Assistance Section (Replaces Newsletter) */}
      <div className="bg-[#f0f7ff] border-b border-gray-200" data-id="element-2809" data-mp="3j1z20zfxqzn2">
        <div className="container mx-auto px-4 py-6 md:py-10" data-id="element-2810" data-mp="3j3jwyq65wklg">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-8" data-id="element-2811" data-mp="3e35ml1h38yk9">
            {/* Left side: Text */}
            <div className="text-center lg:text-left" data-id="element-2812" data-mp="394b5c3yrri29">
              <h2 className="text-lg md:text-2xl font-bold text-[#1E2B55] mb-1 md:mb-2" data-id="element-2813" data-mp="2kcl2p6svuhv4">
                Need Assistance? We're Here to Help!
              </h2>
              <p className="text-gray-600 text-xs md:text-base max-w-2xl" data-id="element-2814" data-mp="2p5xsvld7mwpz">
                Have questions or need support? Our team is just a call or chat
                away. Reach out to us anytime for quick and friendly assistance.
              </p>
            </div>

            {/* Right side: Contact buttons */}
            <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4 w-full sm:w-auto" data-id="element-2815" data-mp="382p4r9qfa9k0">
              {/* Phone Support */}
              <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm border border-blue-100 flex items-center gap-3 md:gap-4 w-full sm:min-w-[240px] md:min-w-[280px]" data-id="element-2816" data-mp="2u1uyoxqukkoi">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0 border border-blue-100" data-id="element-2817" data-mp="1io0ylq8fdnuf">
                  <PhoneIcon className="w-5 h-5 md:w-6 md:h-6 text-[#0066CC]" data-id="element-2818" data-mp="1no5fhhd8wkl6" />
                </div>
                <div className="flex flex-col" data-id="element-2819" data-mp="13jy18b8344c0">
                  <span className="text-[10px] md:text-xs text-gray-500 font-medium whitespace-nowrap" data-id="element-2820" data-mp="zimcs90y5p5e">
                    Got Question? Call us 24/7
                  </span>
                  <a href="tel:043441122" className="text-base md:text-lg font-bold text-[#0066CC] hover:underline" data-id="element-2821" data-mp="ptcjipuda0fp">
                    043441122
                  </a>
                </div>
              </div>

              {/* Chat Support */}
              <div className="bg-white rounded-xl p-3 md:p-4 shadow-sm border border-blue-100 flex items-center gap-3 md:gap-4 w-full sm:min-w-[240px] md:min-w-[280px]" data-id="element-2822" data-mp="btjsetexhi77">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0 border border-blue-100" data-id="element-2823" data-mp="6wjp2q9gqtjs">
                  <MailIcon className="w-5 h-5 md:w-6 md:h-6 text-[#0066CC]" data-id="element-2824" data-mp="21888b4mq9i9z" />
                </div>
                <div className="flex flex-col" data-id="element-2825" data-mp="28ssjis54ceni">
                  <span className="text-[10px] md:text-xs text-gray-500 font-medium whitespace-nowrap" data-id="element-2826" data-mp="28pwlz4x6nrzl">
                    24/7 chat support
                  </span>
                  <button onClick={() => window.openAuthModal?.()} className="text-base md:text-lg font-bold text-[#0066CC] hover:underline text-left" data-id="element-2827" data-mp="2ij50kadq5pow">
                    Chat with Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-6 md:py-10" data-id="element-2828" data-mp="1zqjcwdcz15fe">
        {/* Mobile: Brand Block (Reduced - No Contact Info) */}
        <div className="md:hidden mb-4" data-id="element-2829" data-mp="23qthbll47ns5">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8onJCNEDDvmSU1TZkPymCw/English.png" alt="Innova Pharmacy" className="h-8 mb-3" data-id="element-2830" data-mp="3b70xng77hjm7" />
          <p className="text-xs text-gray-600 mb-3 line-clamp-2" data-id="element-2831" data-mp="3dqe0b2fmrcs0">
            Your trusted source for premium healthcare products and pharmacy
            services.
          </p>
          <div className="flex space-x-2 mb-4" data-id="element-2832" data-mp="3np3k50r377aw">
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2833" data-mp="3npv6rm2phup1">
              <FacebookIcon className="w-3.5 h-3.5" data-id="element-2834" data-mp="k4755payjpn" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2835" data-mp="iazbn2ydtg2">
              <InstagramIcon className="w-3.5 h-3.5" data-id="element-2836" data-mp="a95ksp8dkp0g" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2837" data-mp="5bdws6aupn1j">
              <TwitterIcon className="w-3.5 h-3.5" data-id="element-2838" data-mp="jb52ljr7rx4g" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2839" data-mp="fabhey55owf9">
              <YoutubeIcon className="w-3.5 h-3.5" data-id="element-2840" data-mp="12wothbxi176k" />
            </a>
            <a href="#" className="bg-[#1E2B55] text-white p-1.5 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2841" data-mp="12vvvp0gips0k">
              <LinkedinIcon className="w-3.5 h-3.5" data-id="element-2842" data-mp="tv7ig7yy7voq" />
            </a>
          </div>
        </div>
        {/* Mobile: Collapsible Sections (Removed as per request) */}
        {/* Desktop: Grid Layout */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_1fr] gap-6 md:gap-8" data-id="element-2843" data-mp="jy2qtsmc380j">
          {/* Column 1: About */}
          <div className="lg:col-span-1" data-id="element-2844" data-mp="68935dmketse">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8onJCNEDDvmSU1TZkPymCw/English.png" alt="Innova Pharmacy" className="h-10 mb-4" data-id="element-2845" data-mp="a7hwwihlurny" />
            <p className="text-sm text-gray-600 mb-4" data-id="element-2846" data-mp="17uxg28frvxj">
              Your trusted source for premium healthcare products and pharmacy
              services.
            </p>
            <div className="flex space-x-3 mb-6" data-id="element-2847" data-mp="1y5sfpmqbqufv">
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2848" data-mp="1y4z6mf3w7suk">
                <FacebookIcon className="w-4 h-4" data-id="element-2849" data-mp="1p5m6we5kmin1" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2850" data-mp="1p39ef726spvq">
                <InstagramIcon className="w-4 h-4" data-id="element-2851" data-mp="2hv2u8xec39ce" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2852" data-mp="2cu5bojpewdad">
                <TwitterIcon className="w-4 h-4" data-id="element-2853" data-mp="27xy4yop6yxrd" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2854" data-mp="11h2ylymiu5uy">
                <YoutubeIcon className="w-4 h-4" data-id="element-2855" data-mp="md03kq9nkyfp" />
              </a>
              <a href="#" className="bg-[#1E2B55] text-white p-2 rounded-full hover:bg-[#162041] transition-colors" data-id="element-2856" data-mp="manhq20ry3xd">
                <LinkedinIcon className="w-4 h-4" data-id="element-2857" data-mp="w938g3vw3b6c" />
              </a>
            </div>
            <div className="space-y-2" data-id="element-2858" data-mp="11263kggbeson">
              <div className="flex items-start" data-id="element-2859" data-mp="1137g6pczbn8h">
                <MapPinIcon className="w-4 h-4 text-[#1E2B55] mt-0.5 mr-2 flex-shrink-0" data-id="element-2860" data-mp="151y4c6zgvujg" />
                <p className="text-xs text-gray-600" data-id="element-2861" data-mp="1a19m9jbkl62m">
                  Riyadh, Kingdom of Saudi Arabia
                </p>
              </div>
              <div className="flex items-center" data-id="element-2862" data-mp="1ez2roa51tw1u">
                <PhoneIcon className="w-4 h-4 text-[#1E2B55] mr-2 flex-shrink-0" data-id="element-2863" data-mp="1k0icq27882k8" />
                <p className="text-xs text-gray-600" data-id="element-2864" data-mp="3gssb12dkfw67">+966 11 123 4567</p>
              </div>
              <div className="flex items-center" data-id="element-2865" data-mp="3lrllsn1gx92o">
                <MailIcon className="w-4 h-4 text-[#1E2B55] mr-2 flex-shrink-0" data-id="element-2866" data-mp="3ls580fy5ijmi" />
                <p className="text-xs text-gray-600" data-id="element-2867" data-mp="1riq0ix13bwdb">
                  support@innovapharmacy.com
                </p>
              </div>
            </div>
          </div>
          {/* Column 2: Shop by Category */}
          <div data-id="element-2868" data-mp="2191fdembbpyz">
            <h3 className="text-base font-semibold mb-4" data-id="element-2869" data-mp="218rqxvgx1qve">Shop by Category</h3>
            <ul className="space-y-2" data-id="element-2870" data-mp="1wbsu355vb5ti">
              <li data-id="element-2871" data-mp="1wcua7o1qqii3">
                <a href="/category/prescription-medicines" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2872" data-mp="18knjp5ip55ql">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2873" data-mp="1hllmxllb9984" />
                  Prescription Medicines
                </a>
              </li>
              <li data-id="element-2874" data-mp="1dif7pog807pi">
                <a href="/category/vitamins-supplements" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2875" data-mp="1dm31mopkuw4r">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2876" data-mp="2oym30atevbel" />
                  Vitamins & Supplements
                </a>
              </li>
              <li data-id="element-2877" data-mp="31iam8lmzpzgv">
                <a href="/category/personal-care" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2878" data-mp="31isnxxsf95w6">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2879" data-mp="2rj1vs2rc32z9" />
                  Personal Care
                </a>
              </li>
              <li data-id="element-2880" data-mp="3f9xu7iqaowfh">
                <a href="/category/mother-baby" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2881" data-mp="3fbica8vfamwg">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2882" data-mp="35itcib98ixgy" />
                  Mother & Baby
                </a>
              </li>
              <li data-id="element-2883" data-mp="22w1y175vni3">
                <a href="/category/medical-devices" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2884" data-mp="22dwcdylzwxi">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2885" data-mp="shr9uirknh85" />
                  Medical Devices
                </a>
              </li>
              <li data-id="element-2886" data-mp="wijj3c0g1m4f">
                <a href="/category/health-wellness" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2887" data-mp="wgyx4as73bi6">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2888" data-mp="ngtro66kan6n" />
                  Health & Wellness
                </a>
              </li>
              <li data-id="element-2889" data-mp="djyvvv1ob0w2">
                <a href="/category/beauty-skincare" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2890" data-mp="dkgwt4za63ab">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2891" data-mp="4rndmwgpqjr6" />
                  Beauty & Skincare
                </a>
              </li>
              <li data-id="element-2892" data-mp="3m0k439mhdpy4">
                <a href="/categories" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2893" data-mp="3m23lj3jvi71h">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2894" data-mp="37e3bmj1o7nv0" />
                  View All Categories
                </a>
              </li>
            </ul>
          </div>
          {/* Column 3: Quick Links */}
          <div data-id="element-2895" data-mp="3hcsry7dx5095">
            <h3 className="text-base font-semibold mb-4" data-id="element-2896" data-mp="3h952bjblgxzp">Quick Links</h3>
            <ul className="space-y-2" data-id="element-2897" data-mp="3cb3gwrqp4ml2">
              <li data-id="element-2898" data-mp="3qbxrnh17uzmw">
                <a href="/account" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2899" data-mp="3qbeai2je4f9x">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2900" data-mp="3m8rmkcpubei0" />
                  My Account
                </a>
              </li>
              <li data-id="element-2901" data-mp="3v3xmiv2fj2cm">
                <a href="/account/orders" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2902" data-mp="3v3fu69iw189z">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2903" data-mp="8wh9cfa8ugc9" />
                  Orders & Tracking
                </a>
              </li>
              <li data-id="element-2904" data-mp="fwt7pdmaxdrq">
                <a href="/account/wishlist" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2905" data-mp="kxz1lerp772u">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2906" data-mp="pvr5761pghmv" />
                  Wishlist
                </a>
              </li>
              <li data-id="element-2907" data-mp="zn57tmoydxk8">
                <a href="/cart" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2908" data-mp="znn6epz38nvb">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2909" data-mp="13qbaylgrr8mh" />
                  Shopping Cart
                </a>
              </li>
              <li data-id="element-2910" data-mp="1dllh9le7a262">
                <a href="/store-locator" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2911" data-mp="1dm4p29a4za6d">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2912" data-mp="3fd80v1vriusi" />
                  Store Locator
                </a>
              </li>
              <li data-id="element-2913" data-mp="37wl77vkawhwr">
                <a href="/brands" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2914" data-mp="333s2v8sqvbl7">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2915" data-mp="2y56zj0i74bsj" />
                  Shop by Brand
                </a>
              </li>
              <li data-id="element-2916" data-mp="3qt2wm6bog5pu">
                <a href="/offers" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2917" data-mp="3qtmejn1buu3v">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2918" data-mp="3lsf93umnq70d" />
                  Deals & Offers
                </a>
              </li>
              <li data-id="element-2919" data-mp="3bv25dplqui21">
                <a href="/about-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2920" data-mp="3bvk7v3z01sie">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2921" data-mp="20gf2fs7hhfv3" />
                  About Us
                </a>
              </li>
            </ul>
          </div>
          {/* Column 4: Customer Service */}
          <div data-id="element-2922" data-mp="3u2w12rvhu78b">
            <h3 className="text-base font-semibold mb-4" data-id="element-2923" data-mp="3u3dulgqru7cj">Customer Service</h3>
            <ul className="space-y-2" data-id="element-2924" data-mp="3fdzmsd2ufxz9">
              <li data-id="element-2925" data-mp="3fatxawqayu30">
                <a href="/help-center" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2926" data-mp="3kc152vsg3t9o">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2927" data-mp="bwzilnc2c7gs" />
                  Help Center
                </a>
              </li>
              <li data-id="element-2928" data-mp="1ya9ok259xco">
                <a href="/faq" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2929" data-mp="1ytm5l90ztjb">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2930" data-mp="6yxycz2wi23q" />
                  FAQ
                </a>
              </li>
              <li data-id="element-2931" data-mp="2rnm1r6ioeze6">
                <a href="/contact-us" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2932" data-mp="2ro58rs6sg3df">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2933" data-mp="14r5qwx5u1y9c" />
                  Contact Us
                </a>
              </li>
              <li data-id="element-2934" data-mp="1ipvpyic7q80c">
                <a href="/track-order" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2935" data-mp="1iob3zh3yrxe3">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2936" data-mp="r011enw6imcq" />
                  Track My Order
                </a>
              </li>
              <li data-id="element-2937" data-mp="zrje2otx2k12">
                <a href="/shipping-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2938" data-mp="zs2ycc71hki9">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2939" data-mp="uyzzppnenkv7" />
                  Shipping Policy
                </a>
              </li>
              <li data-id="element-2940" data-mp="38lu0gpjpeum">
                <a href="/return-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2941" data-mp="395bxxf7438n">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2942" data-mp="27cq4x7qi1sqt" />
                  Returns & Refunds
                </a>
              </li>
              <li data-id="element-2943" data-mp="2c6b4v5bnkwsn">
                <a href="/terms-conditions" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2944" data-mp="2h3ba5e0ohvip">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2945" data-mp="1jhdlszzmavyu" />
                  Terms & Conditions
                </a>
              </li>
              <li data-id="element-2946" data-mp="1td75d3br7pq4">
                <a href="/privacy-policy" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2947" data-mp="1tcp6s01mczf1">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2948" data-mp="34tf2gp8f28ue" />
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-2949" data-mp="39qf9b2d3bfmk">
                <a href="/report-issue" className="text-sm text-gray-600 hover:text-[#1E2B55] flex items-center" data-id="element-2950" data-mp="39u30vvyz5ryn">
                  <ArrowRightIcon className="w-3 h-3 mr-2 text-[#1E2B55]" data-id="element-2951" data-mp="t6v1qu5lu2gm" />
                  Report an Issue
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Payment Methods & Copyright - Desktop Only */}
        <div className="hidden md:block mt-10 pt-6 border-t border-gray-200" data-id="element-2952" data-mp="egnr30lu9nqh">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-2953" data-mp="eejja7ktk4kx">
            <div className="w-full md:w-auto" data-id="element-2954" data-mp="adr8vb07ntn2">
              <h4 className="text-sm font-semibold mb-2 flex items-center justify-center md:justify-start" data-id="element-2955" data-mp="5ffzf1dtvl5d">
                <CreditCardIcon className="w-4 h-4 mr-2 text-[#1E2B55]" data-id="element-2956" data-mp="ho2fsybt8ub" />
                Payment Methods
              </h4>
              <div className="flex items-center justify-center md:justify-start space-x-3 flex-wrap gap-y-2" data-id="element-2957" data-mp="1ztgudb69bo06">
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/visa.svg?v=2.1.18" alt="Visa" className="h-8 w-auto" data-id="element-2958" data-mp="1uvp1adtvlvue" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/master-card.svg?v=2.1.18" alt="Mastercard" className="h-8 w-auto" data-id="element-2959" data-mp="18nuyvkzzgfxy" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/mada.svg?v=2.1.18" alt="Mada" className="h-8 w-auto" data-id="element-2960" data-mp="ywql2om1n14p" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/stc-pay.svg?v=2.1.18" alt="STC Pay" className="h-8 w-auto" data-id="element-2961" data-mp="pw287x8dz6te" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/apple-pay.svg?v=2.1.18" alt="Apple Pay" className="h-8 w-auto" data-id="element-2962" data-mp="g1sf2dbme4hm" />
                <img src="https://cdn.niceonesa.com/web/assets_v2/images/tamara.svg?v=2.1.18" alt="Tamara" className="h-8 w-auto" data-id="element-2963" data-mp="2abm8ayyraawv" />
              </div>
            </div>
            <div className="flex flex-col items-center md:items-end gap-2" data-id="element-2964" data-mp="8gpzt70brplm">
              <div className="flex items-center gap-3 text-xs text-gray-600" data-id="element-2965" data-mp="3pzrbkwlr6mp">
                <div className="flex items-center gap-1.5" data-id="element-2966" data-mp="3nwr681qjx49">
                  <GlobeIcon className="w-3.5 h-3.5 text-[#1E2B55]" data-id="element-2967" data-mp="hftjod7bg916" />
                  <span data-id="element-2968" data-mp="dg2lvpjdgsn5">Saudi Arabia (SAR)</span>
                </div>
                <span className="text-gray-300" data-id="element-2969" data-mp="rfakohbmhyqt">|</span>
                <a href="/en" className="hover:text-[#1E2B55] transition-colors font-medium" aria-current="true" data-id="element-2970" data-mp="rdzk0qdh573x">
                  English
                </a>
                <span className="text-gray-300" data-id="element-2971" data-mp="2t8rsbkzr6zlk">·</span>
                <a href="/" className="hover:text-[#1E2B55] transition-colors" data-id="element-2972" data-mp="2o8m4yh0inz9a">
                  Arabic
                </a>
              </div>
              <p className="text-sm text-gray-600 text-center md:text-right" data-id="element-2973" data-mp="jone2adfi449">
                &copy; {new Date().getFullYear()} Innova Pharmacy. All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
        {/* Copyright - Mobile Only */}
        <div className="md:hidden mt-4 pt-4 border-t border-gray-200" data-id="element-2974" data-mp="oii3zvjmnfbs">
          <p className="text-xs text-gray-600 text-center" data-id="element-2975" data-mp="sxa4hlxqxnq">
            &copy; {new Date().getFullYear()} Innova Pharmacy. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}